// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".data-red {\n  color: #FF0000;\n}\n.data-blue {\n  color: #0000ff;\n}\n#tabContainer .data-red input.el-input__inner {\n  color: #FF0000;\n}\n#tabContainer .data-blue input.el-input__inner {\n  color: #0000ff;\n}\n", ""]);
// Exports
module.exports = exports;
